import { render, staticRenderFns } from "./ClaimChat.vue?vue&type=template&id=62c326c9"
import script from "./ClaimChat.vue?vue&type=script&lang=js"
export * from "./ClaimChat.vue?vue&type=script&lang=js"
import style0 from "./ClaimChat.vue?vue&type=style&index=0&id=62c326c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports